import { setCookie } from '@cian/utils/lib/browser/cookie';
import { parseCookies } from '@cian/utils/lib/shared/cookie';

/**
 * Кука, помечающая, что онбординг свайп-реплая уже был показан пользователю.
 * Глобальная: онбординг показывается один раз для всех чатов.
 */
export const REPLY_SWIPE_ONBOARDING_COOKIE = 'chats.replyOnboardingShown';

export const REPLY_SWIPE_ONBOARDING_COOKIE_MAX_AGE = 365 * 86400;

export const isReplySwipeOnboardingShown = (): boolean => {
  return Boolean(parseCookies(document.cookie)[REPLY_SWIPE_ONBOARDING_COOKIE]);
};

export const markReplySwipeOnboardingShown = (): void => {
  setCookie(REPLY_SWIPE_ONBOARDING_COOKIE, '1', {
    path: '/',
    domain: '.cian.ru',
    secure: false,
    expires: REPLY_SWIPE_ONBOARDING_COOKIE_MAX_AGE,
  });
};
